import { render, staticRenderFns } from "./StepNumber.vue?vue&type=template&id=07f5c887&scoped=true"
import script from "./StepNumber.vue?vue&type=script&lang=js"
export * from "./StepNumber.vue?vue&type=script&lang=js"
import style0 from "./StepNumber.vue?vue&type=style&index=0&id=07f5c887&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f5c887",
  null
  
)

export default component.exports